import { Action } from '@ngrx/store';
import { ResponseState } from '../../model/response-result';
import { ActiveRequest } from '../reducers/rest.reducer';

export enum RestActionTypes {
  ResetCounter = '[Rest] Reset Counter',
  BeginRequest = '[Rest] Begin Request',
  EndRequest = '[Rest] End Request',
}

export class ResetCounter implements Action {
  readonly type = RestActionTypes.ResetCounter;

  constructor() { }
}

export class BeginRequest implements Action {
  readonly type = RestActionTypes.BeginRequest;

  // percent: 0-100
  constructor(public showLoading: string | boolean = true, public counting = true, public request: ActiveRequest = null, public percent: number = 0) { }
}

export class EndRequest implements Action {
  readonly type = RestActionTypes.EndRequest;

  constructor(public payload: ResponseState, public showLoading: string | boolean = true, public request: ActiveRequest = null) { }
}


export type RestAction = ResetCounter | BeginRequest | EndRequest;
